module.exports = __webpack_public_path__ + "static/media/oasis_cube_shop3.ed6d8032.webp";